import React from 'react';
import { useParams, Outlet } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/ShopShell.css'; 

export default function ShopShell() {
    const { businessName, salePointName } = useParams();

    return (
        <div className="shop-shell-wrapper">
            <Navbar businessName={businessName} salePointName={salePointName} />
            <main className="shop-shell-main">
                <Outlet context={{ businessName, salePointName }} />
            </main>
            <Footer businessName={businessName} salePointName={salePointName} />
        </div>
    );
}
